import { Box, Typography, Card, IconButton, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Login from '../Login/Login';
import { themeINTEE } from '../../utils/theme';
import backgroundImage from '../../assets/background.jpg';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Groups } from '@mui/icons-material';
import { useNotification } from '../Shared/NotificationProvider';

type LandingPageProps = {
  isAuthenticated: boolean,
  userRole: string
};

function LandingPage({ isAuthenticated, userRole }: LandingPageProps) {
  const navigate = useNavigate();
  const notify = useNotification();


  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {isAuthenticated ? (
        <Card sx={{ padding: themeINTEE.spacing(2) }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Typography variant="h1" gutterBottom>
                Welcome
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <IconButton
                color="primary"
                sx={{ margin: 1, fontSize: 20 }} // Increase the size of the icon
                onClick={() => {
                  if (userRole === 'INTFra' || userRole === 'AdminINTFra') {
                    notify('Access to Experts View is not enabled for INTFra group.', 'warning');
                  } else {
                    navigate('/experts');
                  }
                }}
              >
                <PeopleAltIcon style={{ fontSize: '30' }} />
                Expert Database
              </IconButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <IconButton
                color='primary'
                sx={{ margin: 1, fontSize: 20 }} // Increase the size of the icon
                onClick={() => navigate('/references')}
              >
                <ListAltIcon style={{ fontSize: '30' }} />
                Reference Database
              </IconButton>
            </Grid>
            {userRole !== 'INTFra' && userRole !== 'AdminINTFra' && (
              <Grid item xs={12} md={12}>
                <IconButton
                  color="primary"
                  sx={{ margin: 1, fontSize: 20 }} // Increase the size of the icon
                  onClick={() => {
                    if (userRole === 'INTFra' || userRole === 'AdminINTFra') {
                      notify('Access to Partner View is not enabled for INTFra group.', 'warning');
                    } else {
                      navigate('/partners');
                    }
                  }}
                >
                  <Groups style={{ fontSize: '30' }} />
                  Partner Database
                </IconButton>
              </Grid>)}
          </Grid>
        </Card>
      ) : (
        <Login />
      )}
    </Box>
  );
};

export default LandingPage;